// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "li[data-v-a3b4d270]{font-weight:600!important;padding:.7em 1em!important;text-align:center!important}li+li[data-v-a3b4d270]{border-top:1px solid #ebebeb!important}", "",{"version":3,"sources":["webpack://./chat/vue/widget/ChatModalMenuItem.vue"],"names":[],"mappings":"AACA,oBACE,yBAAA,CAEA,0BAAA,CADA,2BACA,CAOA,uBACE,sCAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
